import { useState } from 'react'
import { OnScreenModal } from '@/components/ui/OnScreenModal'
import { ServiceAgreementEditForm } from './ServiceAgreementEditForm'
import type { ServiceAgreementEditModalProps } from '../types'

/** Inline list modal — sections/drafts match full edit page; drafts are save-on-submit only here. */
export function ServiceAgreementEditModal({
  isOpen,
  document,
  submitting,
  onClose,
  onSubmit,
}: ServiceAgreementEditModalProps) {
  const title = document?.id ? 'Edit Service Agreement' : 'Add Service Agreement'
  const [editorDirty, setEditorDirty] = useState({ content: false, eorp: false })

  return (
    <OnScreenModal isOpen={isOpen} title={title} onClose={onClose} maxWidth="max-w-5xl">
      <ServiceAgreementEditForm
        document={document}
        submitting={submitting}
        draftSaving={false}
        editorDirty={editorDirty}
        hasContentDraft={Boolean(document?.content_draft)}
        hasEorpDraft={Boolean(document?.eorp_section_draft)}
        onContentChange={() => setEditorDirty((d) => ({ ...d, content: true }))}
        onEorpChange={() => setEditorDirty((d) => ({ ...d, eorp: true }))}
        onSaveDraftContent={() => undefined}
        onSaveDraftEorp={() => undefined}
        onDiscardDraftContent={() => undefined}
        onDiscardDraftEorp={() => undefined}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    </OnScreenModal>
  )
}
